import { SpecialPromo } from 'components/main-page/home-page/special-promo/SpecialPromo'
import { useEffect, useState } from 'react'
import { constructOptionsSelect, convertErrorMessage, getValueFromArray, uploadFileToS3 } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_SPECIAL_PROMO } from 'services/api-home-page/apiSpecialPromo'
import { Alert } from 'avo-ui'
import { useValidation } from 'hooks/useValidation'
import { SPECIAL_PROMO_VALIDATION } from 'services/validation/home-page/specialPromoValidation'

const INITIAL_STATE = {
    is_show: false,
    special_promo: {
        title: null,
        title_image_url: null,
        voucher_ids: [],
    },
}

const FIELD_NAME_DETAIL = {
    title: 'Text title',
    title_image_url: 'Image title',
    voucher_ids: 'Voucher list',
}

export const SpecialPromoContainer = () => {
    const [reload, setReload] = useState(false)
    const [specialPromoDetail, setSpecialPromoDetail] = useState(INITIAL_STATE)
    const [optionsVoucher, setOptionsVoucher] = useState([])
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const { fetching: getSpecialPromoDetail, isLoading } = useFetch(API_SPECIAL_PROMO.DETAIL)
    const { fetching: getUrlImageTitle } = useFetch(API_SPECIAL_PROMO.URL_IMAGE_TITLE)
    const { fetching: getVoucherList } = useFetch(API_SPECIAL_PROMO.VOUCHER_LIST)
    const { fetching: updateSpecialPromo, isLoading: isUpdating } = useFetch(API_SPECIAL_PROMO.UPDATE)
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm, errorForm } = useValidation({
        form: specialPromoDetail?.special_promo,
        schema: SPECIAL_PROMO_VALIDATION,
    })

    const onChangeForm = (e) => {
        const { name, value, checked } = e
        let newData
        if (checked === undefined) {
            newData = { special_promo: { ...specialPromoDetail?.special_promo, [name]: value } }
        } else {
            newData = { [name]: checked }
        }
        setSpecialPromoDetail({ ...specialPromoDetail, ...newData })
    }

    const onSearchVoucher = (value = '') => {
        getVoucherList({ search: value }).then((response) => {
            const newOption = constructOptionsSelect(response?.data, 'title', 'id')
            setOptionsVoucher(newOption)
        })
    }

    const setUploadImage = async () => {
        const image = specialPromoDetail?.special_promo?.title_image_url
        try {
            const s3Urls = await getUrlImageTitle({ file: image?.name?.replace(/\s/g, '') })
            await uploadFileToS3(s3Urls?.data, image?.file)
            onSave(`${s3Urls?.data?.url}${s3Urls?.data?.fields.key}`)
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            if (specialPromoDetail?.special_promo?.title_image_url?.name) {
                setIsLoadingUpload(true)
                setUploadImage()
            } else {
                onSave()
            }
        })
    }

    const onSave = (url = specialPromoDetail?.special_promo?.title_image_url) => {
        const newPayload = {
            ...specialPromoDetail,
            special_promo: {
                ...specialPromoDetail?.special_promo,
                title_image_url: url,
                voucher_ids: getValueFromArray(specialPromoDetail?.special_promo?.voucher_ids, 'value'),
            },
        }
        updateSpecialPromo(newPayload)
            .then(() => {
                setReload(!reload)
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Special Promo Updated !',
                })
            })
            .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
    }

    useEffect(() => {
        getSpecialPromoDetail().then((response) => {
            const data = { ...response?.data }
            const { vouchers, ...specialPromoRest } = data?.special_promo
            const newDetail = {
                ...data,
                special_promo: {
                    ...specialPromoRest,
                    voucher_ids: constructOptionsSelect(vouchers, 'title', 'id'),
                },
            }
            setSpecialPromoDetail(newDetail)
        })
        onSearchVoucher()
    }, [reload])

    const props = {
        specialPromoDetail,
        optionsVoucher,
        errorForm: { special_promo: { ...errorForm, ...errorMessage } },
        onChangeForm,
        onSearchVoucher,
        isLoading,
        isUpdating,
        isLoadingUpload,
        onSubmit,
    }

    return <SpecialPromo {...props} />
}
